/* eslint-disable camelcase */
import React from 'react';
import { LazyLink } from '../../../../../../../slices/atoms';

import { TinyNavBarItem } from '../TinyTopNavStyles';
import { TinyNavAnnouncementPill, TinyBarP } from './TinyTopNavAnnouncementStyles';

const TinyTopNavAnnouncement = data => {
  const { announcement_link, announcement_pill_text, announcement_text, rel } = data.navigation;
  return (
    <TinyNavBarItem
      className="g"
      renderAs={LazyLink}
      url={announcement_link && announcement_link.url}
      rel={rel === 'nofollow' ? 'nofollow' : null}
    >
      <TinyNavAnnouncementPill>{announcement_pill_text}</TinyNavAnnouncementPill>
      <TinyBarP>{announcement_text}</TinyBarP>
    </TinyNavBarItem>
  );
};

export default TinyTopNavAnnouncement;
